"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('../../../ui/js/api-header-injector.js');
require('hacktimer');
require('bootstrap');
require('bootstrap-css');
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../../../ui/js/jquery-ui.js');
window['lang'] = getUrlParam('lang');
window['language'] = window['lang'] === null ? 'en' : window['lang'];
require('../../../ui/js/language.js');
require('../js/script.js');
require('../js/menu.js');
require('../../../ui/js/iframe-script.js');
window['API_URL'] = API_URL;
window['$'] = require('jquery');
window['jquery'] = window['$'];
window['jQuery'] = window['$'];
var SPECIAL_API_URL = 'https://api.elbet.us/index.php';
var SPECIAL_API_URL_DOMAINS = ['online.try.everymatrix.elbet.us'];
if (SPECIAL_API_URL_DOMAINS.indexOf(window.location.hostname) >= 0) {
    window['API_URL'] = SPECIAL_API_URL;
    console.log('Special API URL for domain ' + window.location.hostname + ' : ' + SPECIAL_API_URL);
}
require.context('../img', true, /\.(gif|png|jpe?g|svg)$/i);
require('../scss/' + CSS_THEME + '.scss');
require('../../../ui/css/jquery.mCustomScrollbar.css');
var api_1 = require("./api/api");
var slip_1 = require("./slip/slip");
var vfootball_1 = require("./game/vfootball");
var tickets_holder_1 = require("./tickets/tickets-holder");
var user_1 = require("./user/user");
var auth_1 = require("./auth/auth");
var login_modal_helper_1 = require("./helpers/login-modal-helper");
var credit_1 = require("./credit/credit");
var cookie_helper_1 = require("./helpers/cookie-helper");
var navbar_display_1 = require("./navbar/navbar-display");
var chat_1 = require("../../lucky-balls/js/chat");
$(document).ready(function () {
    var api = new api_1.default(window['API_URL'] + '/vfootball');
    api.send('/game-config/get', {}, function (response) {
        window['menu'] = (response['Online_Menu'] !== undefined && response['Online_Menu'] != '' && response['Online_Menu'] != null) ? response['Online_Menu'] : false;
        window['currency'] = response.Currency;
        $('#currency').text(window['currency']);
        window['showLogin'] = (response['showLogin'] !== undefined && response['showLogin'] != '' && response['showLogin'] != null) ? response['showLogin'] : 0;
        if (window['showLogin'] == 1) {
            $('.game-nav-bar').css('display', 'flex');
        }
        else {
            $('.game-nav-bar').css('display', 'none');
        }
        showBettingValues(response);
        setJackpots(response);
        if (window['menu']) {
            $("#nav-icon1").show();
            window['renderMenu']();
        }
    }, function () {
    });
    var slip = new slip_1.default();
    var ticketsHolder = new tickets_holder_1.default();
    var user = new user_1.default();
    var auth = new auth_1.default(api);
    var credit = new credit_1.default(api);
    var navbar = new navbar_display_1.default();
    var game = new vfootball_1.default(api, slip, ticketsHolder, credit, user);
    window.addEventListener('logout', function () {
        auth.logout();
    });
    window.addEventListener('get_credit', function () {
        credit.getCredit(user);
    });
    window.addEventListener('payout', function () {
        credit.requestPayout(user);
    });
    window.addEventListener('get_tickets_no_stats', function () {
        game.getTickets();
    });
    window['customLoggedIn'] = false;
    window['customToken'] = '';
    if (window['showLogin'] != 1 || cookie_helper_1.default.get('token') == '') {
        window['token'] = getUrlParam('token');
    }
    else {
        window['token'] = cookie_helper_1.default.get('token');
    }
    loginManagement(auth, user, navbar, credit);
    if (window['token'] && !/terminal/.test(window.location.href)) {
        chat_1.chat(window['token']);
    }
    game.reload();
    game.attachListeners();
});
$('.payout-pin-button').click(function () {
    var payoutEvent = new CustomEvent("payout");
    window.dispatchEvent(payoutEvent);
});
function setJackpots(response) {
    document.querySelector('.jackpot-amount-val').innerHTML = response['FootBall_JackPotValue'] ? response['FootBall_JackPotValue'].toFixed(2) : '';
    document.querySelector('.mega-jackpot-amount').innerHTML = response['Global_JackPotValue'] ? response['Global_JackPotValue'].toFixed(2) : '';
}
function showBettingValues(response) {
    window['footballMaxWin'] = response['FootBall_MaxWin'];
    $('#betting-values').show();
    $('#slip-btn').val(response['FootBall_DefaultBet']).attr('min', response['FootBall_MinBet']);
    $('#min-bet').text(response['FootBall_MinBet']).attr('data-value', response['FootBall_MinBet']);
    $('#max-bet').text(response['FootBall_MaxBet']).attr('data-value', response['FootBall_MaxBet']);
    $('#slip-btn').attr('max', response['FootBall_MaxBet']);
    $('#bet-100').text(response['CustomAmount1']).attr('data-value', response['CustomAmount1']);
    $('#bet-200').text(response['CustomAmount2']).attr('data-value', response['CustomAmount2']);
    $('#bet-400').text(response['CustomAmount3']).attr('data-value', response['CustomAmount3']);
    $('#betting-btn').val(parseFloat(response['FootBall_MinBet']).toFixed(2))
        .attr('min', response['FootBall_MinBet'])
        .attr('max', response['FootBall_MaxBet'])
        .attr('step', response['FootBall_MinBet']);
}
function getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}
function loginManagement(auth, user, navbar, credit) {
    if (user.isLogggedIn()) {
        window['token'] = cookie_helper_1.default.get('token');
        var response = {
            Data: {
                AuthUserResponse: [
                    {
                        Credit: credit.getCredit(user),
                        Currency: cookie_helper_1.default.get('currency')
                    }
                ]
            }
        };
        navbar.showLogedIn(user, response);
    }
    else {
        navbar.showLogedOut();
    }
    $('.logout-button').click(function () {
        var logoutEvent = new CustomEvent("logout");
        window.dispatchEvent(logoutEvent);
    });
    $('.login-button').click(function () {
        $('.login-modal').modal('show');
    });
    $('.login-user-button').click(function () {
        auth.login(login_modal_helper_1.default.bind(user));
    });
    $('.user-username').on('keydown', function (e) {
        if (e.which == 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.user-password').on('keydown', function (e) {
        if (e.which == 13) {
            auth.login(login_modal_helper_1.default.bind(user));
        }
    });
    $('.login-modal').on('hidden.bs.modal', function () {
        login_modal_helper_1.default.clearloginInputs();
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/ts/main.ts
// module id = 1979
// module chunks = 6